import AuthService from "./AuthService";
import { UsuarioAdmin } from "@/interfaces/adminInterfaces";
import { Profesional } from "@/interfaces/adminInterfaces";
import ProfesionalService from "./ProfesionalService";
import { apiClient } from "./api";
import { RoleNumeros } from "@/_helpers/role";
import { Bar } from "vue-chartjs";

class AdminService {
    private authService: AuthService;
    private profesionalService: ProfesionalService;
    private osURL : string;

    constructor() {
        this.authService = new AuthService();
        this.profesionalService = new ProfesionalService();
        this.osURL = '/ObraSocial';
    }

    async crearUsuario(usuario:UsuarioAdmin, idFacturador: string, idObraSocial: string, idBandeja: string){
        let idUsuario = "";
        let responseRegister: { status: number; data: { id: string; }; };
        const auditorOs = RoleNumeros.Auditor;
        const autorizador = RoleNumeros.Autorizador;
        try {
            responseRegister = await this.authService.register(usuario.username, usuario.email, usuario.rol) as { status: number; data: { id: string; }; };
            if (responseRegister.status === 200) {
                idUsuario = responseRegister.data.id;
                switch (usuario.rol.toString()) {
                    case auditorOs: {
                        const responseAuditor = await this.authService.vincularOSAuditor(idUsuario, idObraSocial);
                        return responseAuditor;
                    }
                    case autorizador: {
                        const responseAutorizador = await this.authService.vincularBandejaAutorizador(idUsuario, idBandeja);
                        return responseAutorizador;
                    }
                    default: {
                        const responseUsuNivFact = await this.authService.crearUsuNivFact(idUsuario, idFacturador);
                        return responseUsuNivFact; 
                    }
                }   
            }
            return responseRegister;
            } catch (error: unknown) {
            if (error instanceof Error) {
                console.error(error.message);
                return error
            } else {
                console.error("Unknown error occurred");
                return error
            }
            }
    }

    async crearProfesional(profesional: Profesional, idFacturador: string){
        let idProfesional = "";
        let responseProfesional: { status: number; data: { id: string; }; };
        try {
            responseProfesional = await this.profesionalService.crearProfesional(profesional) as { status: number; data: { id: string; }; };
            if (responseProfesional && responseProfesional.status === 200) {
                idProfesional = responseProfesional.data.id;
                const responseProfFact = await this.profesionalService.asociarProfesionalFacturador(idProfesional, idFacturador);
                return responseProfFact;
            }
            return responseProfesional;
        } catch (error: unknown) {
            if (error instanceof Error) {
                console.error(error.message);
                return error;
            } else {
                console.error("Unknown error occurred");
                return error;
            }
        }
    }

    async crearObraSocial(obraSocial: object){
        const body = JSON.stringify(obraSocial);
        const endpoint = `${this.osURL}/AgregarObraSocial`;
        try {
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                console.error(error.message);
                return error;
            } else {
                console.error("Unknown error occurred");
                return error;
            }
        }
    }

    async cargarPlanOS(obraSocialId: string, nombrePlan: string){
        const body = JSON.stringify({
            id: obraSocialId,
            nombre: nombrePlan
        });
        const endpoint = `${this.osURL}/PostPlanObraSocial`;
        try {
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                console.error(error.message);
                return error;
            } else {
                console.error("Unknown error occurred");
                return error;
            }
        }
    }
}

export default AdminService;